import { formatPercentage } from 'components/insights/formatting';

import { StatTile, TilesGrid } from '../../shared/slideout/statTiles';

import { TopEntity } from './useSlideoutAnalytics';

export { StatTile, TilesGrid };

type Tone = 'green' | 'red' | 'default';

// Three-tile row used by every rate metric drill (Acceptance, Denial): one rate tile plus a
// top-by receiving partner and a top-by plan, both formatted as "X.X% <ratePhrase>".
export function RateMetricTiles({
  rateLabel,
  rateTone,
  rate,
  count,
  total,
  ratePhrase,
  loading,
  topReceivingLoading,
  topPlanLoading,
  topReceivingLabel,
  topReceiving,
  topPlanLabel,
  topPlan,
}: {
  rateLabel: string;
  rateTone: Tone;
  rate: number | null;
  count: number;
  total: number;
  ratePhrase: string;
  loading: boolean;
  topReceivingLoading: boolean;
  topPlanLoading: boolean;
  topReceivingLabel: string;
  topReceiving: TopEntity;
  topPlanLabel: string;
  topPlan: TopEntity;
}) {
  return (
    <>
      <StatTile
        label={rateLabel}
        tone={rateTone}
        loading={loading}
        primary={formatPercentage(rate)}
        addendum={rate != null ? `${count} of ${total} referrals` : undefined}
      />
      <StatTile
        label={topReceivingLabel}
        loading={topReceivingLoading}
        primary={topReceiving?.name ?? '\u2014'}
        size='medium'
        addendum={topReceiving ? `${formatPercentage(topReceiving.value)} ${ratePhrase}` : undefined}
      />
      <StatTile
        label={topPlanLabel}
        loading={topPlanLoading}
        primary={topPlan?.name ?? '\u2014'}
        size='medium'
        addendum={topPlan ? `${formatPercentage(topPlan.value)} ${ratePhrase}` : undefined}
      />
    </>
  );
}
